import { APIClient } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';

export class DocumentEnumClient extends APIClient {
    public static readonly endpoint = '/document-api/v1';

    public static async fetchDocumentEntityTypes(): Promise<EntityType[]> {
        const response = await this.fetch(`${this.endpoint}/document-entity-types`);
        return await this.handleResponse<EntityType[]>(response);
    }
}
